import { render, staticRenderFns } from "./propertyPricing.vue?vue&type=template&id=77a7b1d8"
import script from "./propertyPricing.vue?vue&type=script&lang=js"
export * from "./propertyPricing.vue?vue&type=script&lang=js"
import style0 from "./propertyPricing.vue?vue&type=style&index=0&id=77a7b1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports